import { Badge } from "@shared/ui/Badge";
import { SchedulingTimeSlotDurationIcon } from "../SchedulingTimeSlotDurationIcon/SchedulingTimeSlotDurationIcon";
import Type from "@shared/ui/Type";

export type Props = {
  duration?: number;
};

export function SchedulingAvailabilityTimeSlotBadge({ duration }: Props) {
  if (!duration) {
    return null;
  }

  return (
    <div className="absolute top-0 left-1/2 transform -translate-y-1/2 -translate-x-1/2 z-20">
      <Badge
        className={`w-18 flex items-center justify-start gap-1 bg-brand-50`}
      >
        <SchedulingTimeSlotDurationIcon duration={duration} />

        <Type variant="caption" className="flex-1 text-center pr-2">
          {`${duration.toFixed(1).replace(/\.0$/, "")} hr`}
        </Type>
      </Badge>
    </div>
  );
}

export default SchedulingAvailabilityTimeSlotBadge;
